import { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import GroupDialog from 'pages/groups/GroupDialog';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Tooltip from '@material-ui/core/Tooltip';
import {
  getGroups,
  createGroup,
  updateGroup,
  updateGroupProducts,
  syncGroupProducts,
  updateLabelPrint,
  updatePaymentSkip,
} from 'actions/groups';
import PeopleIcon from '@material-ui/icons/People';
import SyncProductDialog from 'pages/groups/SyncCompleteDialog';
import {
  Container,
  ItemGroup,
  Item,
  ProductLink,
  Description,
  Text,
  DialogTitle,
} from 'styles/pages/browse-catalog/details.js';

const Groups = () => {
  const [selectedGroup, setGroup] = useState(undefined);
  const [groups, setGroups] = useState(undefined);
  const [syncDialog, setSyncDialog] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchGroups = async () => {
      const data = await dispatch(getGroups());
      setGroups(data);
    };

    if (groups === undefined) {
      fetchGroups();
    }
  }, [dispatch, groups]);

  return (
    <div style={{ padding: 15 }}>
      <Container>
        <DialogTitle>
          Groups ({groups?.length})
          <Tooltip title='Create Group'>
            <AddCircleIcon
              style={{
                float: 'right',
                cursor: 'pointer',
                color: '#000',
                marginTop: '5px',
                fontSize: 30,
              }}
              onClick={() => setGroup({})}
            />
          </Tooltip>
        </DialogTitle>

        <ItemGroup style={{ gridTemplateColumns: 'repeat(7,1fr)' }}>
          {groups?.map((item, index) => {
            return (
              <Item key={`group${index}`}>
                <ProductLink>
                  <Description>
                    <PeopleIcon
                      onClick={() => setGroup(item)}
                      style={{
                        fontSize: 100,
                        color: '#000',
                        display: 'block',
                        margin: '0 auto',
                      }}
                    />
                    <Text
                      onClick={() => setGroup(item)}
                      style={{
                        fontSize: 20,
                        borderBottom: '1px solid black',
                        paddingBottom: 10,
                        marginBottom: 10,
                      }}>
                      {item.name}
                    </Text>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>Print Label</Text>
                      <Switch
                        color='primary'
                        checked={item?.PrintLabel}
                        onChange={async (e) => {
                          const checked = e.target.checked;
                          const payload = {
                            groupName: item.name,
                            printLabel: checked,
                          };
                          await dispatch(updateLabelPrint(payload));
                          setGroups(
                            groups?.map((g, j) => {
                              if (index !== j) {
                                return g;
                              }
                              return { ...g, PrintLabel: checked };
                            })
                          );
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>Payment Skip</Text>
                      <Switch
                        color='primary'
                        checked={item?.PaymentSkip}
                        onChange={async (e) => {
                          const checked = e.target.checked;
                          const payload = {
                            groupName: item.name,
                            paymentSkip: checked,
                          };
                          await dispatch(updatePaymentSkip(payload));
                          setGroups(
                            groups?.map((g, j) => {
                              if (index !== j) {
                                return g;
                              }
                              return { ...g, PaymentSkip: checked };
                            })
                          );
                        }}
                      />
                    </div>
                  </Description>
                </ProductLink>
              </Item>
            );
          })}
        </ItemGroup>
        {!!selectedGroup && (
          <GroupDialog
            groups={groups}
            open={!!selectedGroup}
            group={selectedGroup}
            setModal={(v) => setGroup(undefined)}
            createGroup={async (groupName) => {
              const isExist = !!_.find(
                groups,
                (g) =>
                  g?.name?.split(' ').join('_') ===
                  groupName.split(' ').join('_')
              );

              if (isExist) {
                alert(
                  'This group is already exist, please change the entered group name.'
                );
                return;
              }

              await dispatch(
                createGroup({ groupName: groupName.split(' ').join('_') })
              );
              setGroup(undefined);
              setGroups(undefined);
            }}
            onShift={async (data) => {
              await dispatch(updateGroup(data));
              setGroup(undefined);
              setGroups(undefined);
            }}
            onProductsSave={async (data) =>
              await dispatch(updateGroupProducts(data))
            }
            syncGroupProducts={async () => {
              await dispatch(
                syncGroupProducts({ groupName: selectedGroup?.name })
              );
              setGroup(undefined);
              setGroups(undefined);
              setSyncDialog(true);
            }}
          />
        )}
        {syncDialog && (
          <SyncProductDialog
            open={syncDialog}
            setModal={() => setSyncDialog(false)}
          />
        )}
      </Container>
    </div>
  );
};

export default Groups;
